<div style="position: relative; min-height: 20rem">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div class="devices-wrapper conversion-wrapper">
		<div class="device-chart-data">
			<div
				class="devices-chart-div conversions-chart-div {{ deviceCount }}"
				*ngFor="let config of multichartconfigurations; let i = index"
			>
				<div *ngIf="!hasData">
					<div class="map-no-data c-portlet no-data-div">{{ nodatamessage }}</div>
				</div>
				<div *ngIf="hasData">
					<app-generic-chart
						id="device-id-{{ i }}"
						[configuration]="config"
						[colorPalette]="colorPalette"
						[data]="devicesChartData"
					>
					</app-generic-chart>
				</div>
			</div>
		</div>

		<div
			class="legend-detail {{ deviceCount }}"
			[ngClass]="{
				'device-legend-datatable': true,
				'ctv-legend': isCTV
			}"
		>
			<div
				class="legend-detail {{ sectionclass }} {{ dataLengthClass }}"
				*ngFor="let datatableConfig of multidatatableconfigurations"
			>
				<ngx-datatable
					class="dataTable"
					[rows]="deviceLegendData"
					[columns]="datatableConfig['columns']"
					[columnMode]="'force'"
					[footerHeight]="0"
					[reorderable]="false"
					[virtualization]="false"
					[headerHeight]="38"
				>
					<ng-template ngFor let-column [ngForOf]="datatableConfig['columns']">
						<ngx-datatable-column
							name="{{ column.name }}"
							prop="{{ column.prop }}"
							[cellClass]="column.cellClass"
							[headerClass]="column.headerClass"
							[resizeable]="false"
							[sortable]="false"
						>
							<ng-template ngx-datatable-cell-template let-value="value" let-rowIndex="rowIndex" let-row="row">
								<div class="datatable-row">
									<span [attr.class]="column.headerClass"
										><span [ngClass]="getDeviceColor(row[column.prop])">{{ row[column.prop] }}</span></span
									>
									<span [attr.class]="!hasData ? 'postpend no-data' : 'postpend'">{{ column['columnSuffix'] }}</span>
									<ng-template ngFor let-complexProp [ngForOf]="column.complexProperty">
										<span [attr.class]="!hasData ? 'prepend no-data' : 'prepend'">{{ complexProp.prepend }}</span>
										<span [ngStyle]="complexProp.styles" [attr.class]="complexProp.cssClass">{{
											row[complexProp.propertyKey]
										}}</span>
										<span [attr.class]="!hasData ? 'postpend no-data' : 'postpend'">{{ complexProp.postpend }}</span>
									</ng-template>
								</div>
							</ng-template>
						</ngx-datatable-column>
					</ng-template>
				</ngx-datatable>
			</div>
		</div>

		<div class="metrics-header">
			<div class="sem-conversion-metrics" *ngFor="let metric of metricObject">
				<div class="conversion-metrics">
					<div class="metric-value" appTooltip [attr.title]="metric?.tooltip" [options]="tooltipOptions">
						{{ metric.value }}
					</div>
					<div class="metric-name">
						{{ metric.name }}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
